module.exports = __webpack_public_path__ + "img/608.c7309720.png";